module.exports = new __parcel__URL__("wb-press-logo.3dd4f6a4.png").toString();